import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { FastField, FormikErrors, FormikProps, useFormikContext } from "formik";
import React, { ChangeEvent, useState } from "react";
import CustomizedSwitch from "../../../../../common/formElements/Switch";
import TextInput from "../../../../../common/formElements/TextInput";
import OrderedList from "../../../../../common/OrderedList";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
import SectionContainer from "../../../../../common/SectionContainer";
import CustomizedTooltip from "../../../../../common/toolTip/CustomizedTooltip";
import {
  Data,
  OfflineConfig,
  OfflineLimits,
} from "../../../../../store/terminal/types";
import { get, values } from "lodash";
import produce from "immer";
import { DropResult } from "smooth-dnd/dist/src/exportTypes";
import SelectDropDown from "../../../../../common/formElements/SelectDropDown";
import { connect, useSelector } from "react-redux";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";
import { ApplicationState } from "../../../../../store";

let productSchemesState: any = [
  "EFTPOS",
  "MASTERCARD DEBIT",
  "MASTERCARD CREDIT",
  "VISA DEBIT",
  "VISA CREDIT",
  "AMEX",
  "JCB",
  "DINERS",
  "UNIONPAY CREDIT",
  "UNIONPAY DEBIT",
  "Cabcharge Gift Card",
  "DISCOVER",
  "AMEX INTERNATIONAL",
  "DINERS INTERNATIONAL",
  "JCB INTERNATIONAL PTY LIMITED",
  "MASTERCARD INTERNATIONAL",
  "VISA INTERNATIONAL",
  "UNIONPAY INTERNATIONAL",
  "DISCOVER INTERNATIONAL",
];

let productFuelState: any = [
  "BP Card",
  "BP Gift Card",
  "Fleet Card",
  "Shell Card",
  "Motorpass",
  "Motorcharge",
  "Ampol Card",
  "Freedom Fuel Card",
  "Trinity Fuel Card",
  "Liberty Card",
  "Caltex StarCard",
  "United Fuel Card",
];
interface OfflineLimitsProps {
  offlineLimits: OfflineLimits;
  index: number;
  onChange?: (
    attribute: string
  ) => (event: ChangeEvent<{ value: unknown }>) => void;
  values?: any;
  errors?: FormikErrors<Data>;
  disabled?: boolean;
  isUpdateAllowed?: boolean;
}

const OfflineLimitsListItem = (props: OfflineLimitsProps) => {
  const formProps = useFormikContext<FormikProps<Data>>();
  const values = formProps.values as unknown as Data;

  const { OfflineLimits } = values.attributes;

  const { index, disabled } = props;

  return (
    <Grid container xs={12} md={12} spacing={2}>
      <Grid item xs={6} md={6}>
        <FormControl fullWidth variant="outlined" disabled={disabled}>
          <InputLabel id="category" disabled={disabled}>
            Category
          </InputLabel>
          <FastField
            as={Select}
            name={`attributes.OfflineLimits[${index}].Category`}
            labelId="category"
            label="Category"
            variant="outlined"
            disabled={disabled}
            key={`Category_${OfflineLimits}`}
          >
            <MenuItem value="Schemes">Schemes</MenuItem>
            <MenuItem value="Fuel">Fuel</MenuItem>
          </FastField>
        </FormControl>
      </Grid>
      <Grid item xs={6} md={6}>
        {values.attributes.OfflineLimits[index].Category === "Schemes" ? (
          <SelectDropDown
            key={`Product_${OfflineLimits}`}
            label="Product"
            fieldname={`attributes.OfflineLimits[${index}].Product`}
            options={productSchemesState}
          />
        ) : (
          <SelectDropDown
            key={`Product_${OfflineLimits}`}
            label="Product"
            fieldname={`attributes.OfflineLimits[${index}].Product`}
            options={productFuelState}
          />
        )}
      </Grid>
      <Grid item xs={6} md={6}>
        <TextInput
          key={`Amount_${OfflineLimits}`}
          type="number"
          fieldname={`attributes.OfflineLimits[${index}].Amount`}
          label="Amount"
        />
      </Grid>
    </Grid>
  );
};
interface EditOfflineProcessingComponentProps {
  bulk: boolean;
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const EditOfflineProcessingComponent = (
  props: EditOfflineProcessingComponentProps
) => {
  const formProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue, errors } = formProps;
  const values = formProps.values as unknown as Data;
  const paymentTypeGroups = useSelector((state: ApplicationState) => state.offlinePaymentTypeGroup.data) ?? [];
  console.log(paymentTypeGroups)

  const { isUpdateAllowed, shouldHideField, bulk } = props;

  const { OfflineLimits } = values.attributes;

  const initialCount = OfflineLimits ? OfflineLimits.length : 0;

  const [offlineLimitsInstanceCount, setOfflineLimitsInstanceCount] =
    useState(initialCount);

  const checkedEnabled =
    values &&
    values.attributes &&
    values.attributes.OfflineConfig &&
    get(values, "attributes.OfflineConfig.Enabled") === "Yes";

  const checkedOfflineFirst =
    values &&
    values.attributes &&
    values.attributes.OfflineConfig &&
    get(values, "attributes.OfflineConfig.OfflineFirst") === "Yes";

  const OfflineProcessingChangeListenerBuilder =
    (index: number, setFieldValue: (field: string, value: any) => void) =>
    (attributeName: string) =>
    (event: ChangeEvent<{ value: unknown }>) => {
      if (setFieldValue && index > -1) {
        const newItems = produce(OfflineLimits, (draft: OfflineLimits[]) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          draft[index][attributeName] = event.target.value;
        });
        setFieldValue("attributes.OfflineLimits", newItems);
      }
    };

  const onOfflineLimitsDrop = ({ removedIndex, addedIndex }: DropResult) => {
    if (setFieldValue && removedIndex !== null && addedIndex !== null) {
      const newItems = produce(OfflineLimits, (draft: OfflineLimits[]) => {
        const items = draft.splice(removedIndex, 1);
        draft.splice(addedIndex, 0, ...items);
      });
      setFieldValue("attributes.OfflineLimits", newItems);
    }
  };

  const onOfflineLimitsAdd = () => {
    if (setFieldValue) {
      setFieldValue(
        "attributes.OfflineLimits",
        produce(OfflineLimits, (draft: OfflineLimits[]) => {
          draft.push({
            Category: "",
            Product: "",
            Amount: 0,
          });
          setOfflineLimitsInstanceCount(offlineLimitsInstanceCount + 1);
        })
      );
    }
  };

  const onOfflineLimitsDelete = (index: number) => {
    if (setFieldValue) {
      setFieldValue(
        "attributes.OfflineLimits",
        produce(OfflineLimits, (draft: OfflineLimits[]) => {
          draft.splice(index, 1);
          setOfflineLimitsInstanceCount(offlineLimitsInstanceCount - 1);
        })
      );
    }
  };

  return (
    <SectionContainer
      name="sections.OfflineProcessing"
      heading="Offline Processing"
    >
      <SectionWrapper isChild={true} title="Configuration">
        <Grid container xs={12} md={12} spacing={2}>
          <Grid item xs={12} md={12}>
            <Box p={2} pt={0}>
              <CustomizedTooltip title="When enabled, users can set offline limits per scheme and enable the 'online first' flag">
                <FormControlLabel
                  style={{ marginRight: "3rem" }}
                  control={
                    <CustomizedSwitch
                      name={"attributes.OfflineConfig.Enabled"}
                      checked={checkedEnabled}
                      onChange={(event) => {
                        const newValue = event.target.checked ? "Yes" : "No";
                        setFieldValue(
                          "attributes.OfflineConfig.Enabled",
                          newValue
                        );
                        if (newValue === "No") {
                          setFieldValue(
                            "attributes.OfflineConfig.OfflineFirst",
                            "No"
                          );
                        }
                      }}
                      disabled={!isUpdateAllowed}
                    />
                  }
                  label="Offline processing"
                />
              </CustomizedTooltip>
              <CustomizedTooltip title="When enabled, offline processing is attempted first">
                <FormControlLabel
                  control={
                    <CustomizedSwitch
                      name={"attributes.OfflineConfig.OfflineFirst"}
                      checked={checkedOfflineFirst}
                      onChange={(event) => {
                        setFieldValue(
                          "attributes.OfflineConfig.OfflineFirst",
                          event.target.checked ? "Yes" : "No"
                        );
                      }}
                      disabled={checkedEnabled ? false : true}
                    />
                  }
                  label="Offline first"
                />
              </CustomizedTooltip>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextInput
              fieldname={`attributes.OfflineConfig.OpenLoopFloorLimit`}
              label="Open Loop Floor Limit"
              type="number"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextInput
              fieldname={`attributes.OfflineConfig.CloseLoopFloorLimit`}
              label="Close Loop Floor Limit"
              type="number"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextInput
              fieldname={`attributes.OfflineConfig.LimitTotal`}
              label="Limit Total"
              type="number"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextInput
              fieldname={`attributes.OfflineConfig.LimitCount`}
              label="Limit Count"
              type="number"
            />
          </Grid>
          {/*TODO: enable it later*/}
          {/*<Grid item xs={12} md={3}>*/}
          {/*  <SelectDropDown*/}
          {/*    disabled={!isUpdateAllowed}*/}
          {/*    fieldname="attributes.OfflineConfig.PaymentTypeGroup"*/}
          {/*    label="Payment Type Group"*/}
          {/*    options={paymentTypeGroups?.map(*/}
          {/*      (option) => option?.attributes?.Name || ""*/}
          {/*    )}*/}
          {/*  />*/}
          {/*</Grid>*/}
        </Grid>
      </SectionWrapper>
    </SectionContainer>
  );
};

const ConnectedOfflineProcessing = connect(
  null,
  null,
  (
    _stateProps,
    _dispatchProp,
    ownProps: EditOfflineProcessingComponentProps
  ) => {
    return {
      ...ownProps,
      shouldHideField: ownProps.shouldHideField,
      bulk: ownProps.bulk,
    };
  }
)(EditOfflineProcessingComponent);

const ConnectedOfflineProcessingHoc = (
  props: EditOfflineProcessingComponentProps
) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedOfflineProcessing {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedOfflineProcessingHoc;
